import Cookies from 'universal-cookie';
import { REDUX_COOKIES_UPDATE } from './actions';
export function createReducer(cookies) {
    const cookieWorker = new Cookies(cookies);
    return function reducer(state = getState(cookieWorker), action) {
        if (action.type === REDUX_COOKIES_UPDATE) {
            if (action.payload.value === undefined) {
                cookieWorker.remove(action.payload.name);
            }
            else {
                cookieWorker.set(action.payload.name, action.payload.value, action.payload.options);
            }
            return getState(cookieWorker);
        }
        return state;
    };
}
function getState(cookieWorker) {
    return {
        cookies: Object.assign({}, cookieWorker.getAll()),
    };
}
//# sourceMappingURL=reducer.js.map